'use strict';
import { cn_marker_input } from '../svg/cn_inputs';
import { cn_element_visitor } from '../utils/visitors/cn_element_visitor';
import { cn_marker } from './cn_marker';
//***********************************************************************************
//***********************************************************************************
//******     CN-Map    **************************************************************
//******     Copyright(C) 2019-2021 EnerBIM                        ******************
//***********************************************************************************
//***********************************************************************************

//***********************************************************************************
//***********************************************************************************
//**** cn_sampling : sampling for element of a zpso
//***********************************************************************************
//***********************************************************************************

import { cn_storey } from './cn_storey';
import { cn_wall } from './cn_wall';

export class cn_sampling extends cn_marker {
    //***********************************************************************************
    /**
     * Constructor
     *
     * @param {cn_storey} storey
     */
    constructor(storey, type = '', free_position = false) {
        super(storey, type);
        this.class_name = 'cn_sampling';
        this.zpso = '';
        this.control_result = '';
        this.support = '';
        this.free_position = free_position;
        // overrides cn_marker default
        this.anomaly = false;
    }

    //***********************************************************************************
    /**
     * Construct from marker
     * @param {cn_marker} marker
     * @returns {cn_sampling}
     */
    static generateFromMarker(marker) {
        return Object.assign(new cn_sampling(marker.storey), marker);
    }

    /**
     *
     * @param {cn_marker_input} input_marker
     */
    hydrate_input_specific_params(input_marker) {
        input_marker.specific_params = { control_result: this.control_result, zpso: this.zpso }
    }

    /**
     *
     * @param {cn_marker_input} input_marker
     */
    reconcialite_input_specific_params(input_marker) {
        this.control_result = input_marker.specific_params.control_result || '';
        this.zpso = input_marker.specific_params.zpso || '';
    }

    _draw_head(p0, pp1, pp2, camera, extra) {
        let html = '';

        if (this.support === 'ceil') {
            html = `<circle class="marker_arrow ${extra}" cx="${p0[0]}" cy="${p0[1]}" r="6"></circle>`;
        } else if (this.support === 'floor') {
            html = `<rect class="marker_arrow ${extra}" x="${p0[0] - 6}" y="${p0[1] - 6}" width="12" height="12"></rect>`;
        } else {

            if ((this.element && this.element instanceof cn_wall) || this.support !== 'other') {
                html = super._draw_head(p0, pp1, pp2, camera, extra);
            } else {
                html = `<path class="marker_arrow marker_cross ${extra}" d="M ${p0[0] - 6} ${p0[1] - 6}
                L ${p0[0] + 6} ${p0[1] + 6} M ${p0[0] + 6} ${p0[1] - 6} L ${p0[0] - 6} ${p0[1] + 6}" transform="rotate(45, ${p0[0]}, ${p0[1]})"/>`;
            }
        }

        return html;
    }

    _extra_class() {
        const result = [];
        if (this.control_result === 'Amianté') {
            result.push('sampling_amianted');
        } else if (this.control_result === 'Non amianté') {
            result.push('sampling_not_amianted');
        }
        return result;
    }

    _textbox_class() {
        return ['sampling_text', ...this._extra_class()];
    }

    _draw_marker_icon(point, orientation_sign) {
        return `<image  x="${point[0] - 9 + 15 * orientation_sign}" y="${point[1] - 9}" href="data:image/png;base64,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" height="18px" width="18px"/>`;
    }

    serialize() {
        const json = super.serialize();
        json.zpso = this.zpso || '';
        json.control_result = this.control_result || '';
        json.support = this.support || 'wall';
        json.free_position = this.free_position || false;
        json.storey_index = this.storey.storey_index;
        return json;
    }

    //***********************************************************************************
    /**
     * Unserialize method
     * @param {object} json
     * @param {cn_storey} storey
     * @returns {cn_sampling}
     */
    static unserialize(json, storey) {
        const marker = Object.assign(new cn_sampling(storey), cn_marker.unserialize(json, storey));
        marker.support = json.support || 'wall';
        marker.zpso = json.zpso || '';
        marker.control_result = json.control_result || '';
        marker.free_position = json.free_position || false;
        return marker;
    }

    _search_element(roof, position, tolerance) {
        const scene = this.storey.scene;
        if (!this.free_position) {
            if (!roof) {
                if (this.support === 'other') {
                    [
                        scene.find_object_instance,
                        scene.find_mmm_element,
                        scene.find_beam,
                        scene.find_opening,
                        scene.find_column,
                        scene.find_stairs,
                        scene.find_pipe
                    ].forEach(searchFunction => {
                        if (!this.element) {
                            this.element = searchFunction.apply(scene, [position, tolerance]);
                        }
                    });
                } else if (this.support === 'wall') {
                    this.element = scene.find_space_segment(position, tolerance)
                } else {
                    this.element = this.storey.find_slab(position, tolerance);
                    if (!this.element) {
                        this.element = scene.find_space(position, tolerance);
                    }
                }
            } else {
                const roof = this.storey.roof;
                this.element = roof.find_opening(position);

                if (!this.element)
                    this.element = roof.find_slab(position);
            }
        } else {
            this.element = scene.find_space(position, tolerance);
        }
    }

    /**
     * Accept element visitor
     *
     * @param {cn_element_visitor} element_visitor
     */
    accept_visitor(element_visitor) {
        element_visitor.visit_sampling(this);
    }

}
